
import { Component, Prop, Vue } from 'vue-property-decorator';
import TicketRepositoryInterface, { CronFilterInterface } from '@/services/QC-V2/ticket/interfaces';

@Component({
  inject: [
    'ticketRepositoryV2',
  ],
})
export default class DeleteFilterDialog extends Vue {
  private readonly ticketRepositoryV2!: TicketRepositoryInterface;

  @Prop() private readonly filter!: CronFilterInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete filter ${this.filter.property}?`;
  }

  private async deleteFilter(): Promise<void> {
    try {
      await this.ticketRepositoryV2.deleteCronFilter(this.filter.id);
      this.$successDialog.show(`Filter ${this.filter.property} has been deleted.`);
      this.$emit('deleted-filter');
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
